















import Vue, { PropType } from "vue";
import log from "loglevel";
import { hasValue } from "@/ts/utils";

export type SelectItem = {
  key: string;
  label: string;
};

export default Vue.extend({
  name: "PopupSelectButton",
  props: {
    items: { type: Array as PropType<SelectItem[]>, required: true },
    align: { type: String, default: "left" }, // left, center, right
    popupWidth: { type: Number, required: false },
    closeOnSelect: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    onSelect: { type: Function as PropType<(key: string) => void>, required: true },
  },
  data(): {
    showPopup: boolean;
  } {
    return {
      showPopup: false,
    };
  },
  computed: {
    styles() {
      return {
        "--white-space": hasValue(this.popupWidth) ? "normal" : "nowrap",
        "--popup-width": hasValue(this.popupWidth) ? `${this.popupWidth}px` : "auto",
      };
    },
  },
  methods: {
    togglePopup() {
      if (this.disabled || this.items.length === 0) {
        this.showPopup = false;
      } else {
        this.showPopup = !this.showPopup;
      }
    },
    onClickOutside() {
      this.showPopup = false;
    },
    onClickItem(key: string) {
      log.debug(`onClickItem: key=${key}`);
      // this.$emit("input", key);
      this.onSelect(key);
      if (this.closeOnSelect) {
        this.showPopup = false;
      }
    },
  },
});
